import React from 'react';
import styled from 'styled-components';

// Styled component for star ratings
const StarRatingsContainer = styled.div`
  --rating: ${(props) => props.rating};
  unicode-bidi: bidi-override;
  color: #c5c5c5;
  font-size: ${(props) => props.size}px;
  width: 125px;
  position: relative;
  padding: 0;
  margin: 0;
  
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-family: Times;
  line-height: 1;

  &::before {
    content: "★★★★★";
    letter-spacing: 3px;
    background: linear-gradient(90deg, #ffb446 var(--percent), #CCC var(--percent));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Stars = ({ numOfStars, size = 25 }) => {
    return (
        <StarRatingsContainer rating={numOfStars} size={size}/>
    );
};

export default Stars;
